export function commonFunc() {
  $('.tab-list').on('click', function () {
    $(this).parent().find('.tab-list').removeClass('active');
    $(this).parent().next('.tab-container-js').children('.tab-pane').removeClass('active');
    var target = $('#' + $(this).data('target'));
    target.addClass('active');
    $(this).addClass('active');
  });

  $('.dd-toggle').on('click', function () {
    $(this).next('.dd-target').stop().slideToggle();
    $(this).toggleClass('active');
  });

  $('.table-toggle').on('click', function () {
    $(this).next('.table-target').stop().slideToggle();
    $(this).toggleClass('active');
  });

  $('.modal-toggle').on('click', function () {
    $(this).toggleClass('open');
    $(this).next('.modal-content').toggleClass('open');
  });

  $('.modal-close').on('click', function () {
    $(this).parents('.modal-content').removeClass('open');
    $(this).parents('.modal-content').prev('.modal-toggle').removeClass('open');
  });


  //ブラウザの高さ取得
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
}